import React from "react";
import { Outlet } from "react-router-dom";
import SideBar from "../components/Sidebar/index";
import Header from "../components/Header/index";
const Layout = () => {
  return (
    <div className="bgLayout min-h-screen lg:h-screen  w-screen overflow-hidden flex flex-row flex-col-reverse flex-row-reverse md:flex md:flex-col md:flex-col-reverse lg:flex lg:flex-row">
      <SideBar />
      <div className="flex flex-col flex-1 ">
        <Header />
        <div className="flex-1 p-2  lg:p-4 min-h-0 overflow-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
